import { Helmet } from "react-helmet-async";
import { WORKFLOW } from "./appConfig";

const WALKY_GTM = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TRHQRQ3N');
`;

const EASYFIT_GTM = `
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-K2L2PTKV");
`;

const IS_WALKY = WORKFLOW === "WALKY";

const WALKY_APPHUD_API_KEY = "app_h2JqckqsD6Na2PRDyaf4q6TGBm7Efv";

const APPHUD_INIT = (apiKey) => `
  apphud.init({ apiKey: "${apiKey}", version: "1.0", debug: false });
apphud_user_id = apphud.getUserID()
`;

export const HeadConfig = () => {
  console.log("WorkFlow: " + process.env.REACT_APP_WORKFLOW);

  const isWalky = IS_WALKY || window.location.host.includes("walky");

  if (!WORKFLOW) {
    return null;
  }

  return (
    <Helmet>
      <title>{isWalky ? "Walky" : "EasyFit"}</title>
      <meta name="theme-color" content={isWalky ? "#E7394F" : "#000000"} />
      <script>{isWalky ? WALKY_GTM : EASYFIT_GTM}</script>
      {/* <script>{isWalky && APPHUD_INIT(WALKY_APPHUD_API_KEY)}</script> */}
    </Helmet>
  );
};
